export default Object.freeze({
  DARK: 'Dark',
  LIGHT: 'Light',
  WHITE: 'White',
})
